import { Button, Form, Input, message, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { generateVgInstruction } from "pages/dashboard/automation/service";
import { useEffect, useState } from "react";
function Footer({ onClose, onSubmit, onDelete, clearDisabled }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        <Button
          type="primary"
          className={`primaryButton ${!clearDisabled && "bordered danger"}`}
          onClick={onDelete}
          disabled={clearDisabled}
        >
          Clear Instruction
        </Button>
      </div>
      <div>
        <Button
          type="default"
          className="primaryButton bordered"
          onClick={onClose}
          style={{ marginRight: "8px" }}
        >
          Cancel
        </Button>
        <Button type="primary" className="primaryButton" onClick={onSubmit}>
          Confirm
        </Button>
      </div>
    </div>
  );
}
export function VgInstructionModal({ visible, onClose, onSave, data }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const disableGenerate = Form.useWatch(
    (values) =>
      !(values.triggerCondition && values.messageIntention && values.courtesy),
    form,
  );
  const [instruction, setInstruction] = useState("");
  useEffect(() => {
    form.setFieldsValue(data.customPromptCfg);
    setInstruction(data.customPrompt);
  }, [data]);
  function onSubmit() {
    onSave(instruction, form.getFieldsValue());
    onClose();
  }
  function onDelete() {
    onSave("", form.getFieldsValue());
    // onClose();
  }
  async function onGenerateInstruction() {
    setErrorMessage("");
    setLoading(true);
    const values = form.getFieldsValue();
    try {
      const res = await generateVgInstruction(
        values.courtesy,
        values.messageIntention,
        values.triggerCondition,
      );
      if (res.status === 200 && res.data.valid) {
        setInstruction(res.data.customPrompt);
      } else {
        setErrorMessage(
          res.data.reason ? res.data.reason : "Failed to generate instruction",
        );
      }
    } finally {
      setLoading(false);
    }
  }
  return (
    <Modal
      title="Customize Virtual Guard Instruction"
      open={visible}
      onCancel={onClose}
      centered
      width={600}
      footer={
        <Footer
          onClose={onClose}
          onSubmit={onSubmit}
          onDelete={onDelete}
          clearDisabled={!instruction}
        />
      }
    >
      <div style={{ fontSize: "16px", fontWeight: "600" }}>
        Define how Virtual Guard should respond. Once the instruction is
        generated, submit it to activate the behavior.
      </div>
      <Form layout="vertical" form={form}>
        <Form.Item label="Trigger Condition" name="triggerCondition">
          <TextArea
            placeholder={`(Under what situation you need to trigger virtual guard broadcast?) e.g.
1.When the door is left open and nobody is closing it.
2.When someone is running in the sight.`}
            count={{
              max: 300,
              show: true,
              exceedFormatter: (value, config) => {
                return value.substring(0, config.max);
              },
            }}
          />
        </Form.Item>
        <Form.Item label="Message Intention" name="messageIntention">
          <TextArea
            placeholder={`(What is the purpose of the broadcasting message when virtual guard is triggered?) e.g.
1.On trigger condition 1, remind someone to close the door.
2.On trigger condition 2, make the running person stop running.`}
            count={{
              max: 300,
              show: true,
              exceedFormatter: (value, config) => {
                return value.substring(0, config.max);
              },
            }}
          />
        </Form.Item>
        <Form.Item label="Courtesy" name="courtesy">
          <TextArea
            placeholder={`(How polite you want the virtual guard to be?) e.g.
1.Be polite and gentle at the trigger condition 1.
2.Be strict at the trigger condition 2.`}
            count={{
              max: 300,
              show: true,
              exceedFormatter: (value, config) => {
                return value.substring(0, config.max);
              },
            }}
          />
        </Form.Item>
        <Form.Item help={errorMessage}>
          <Button
            loading={loading}
            disabled={!!instruction || disableGenerate}
            onClick={onGenerateInstruction}
            type="primary"
            className={`primaryButton ${!instruction && !disableGenerate && "bordered"}`}
            style={{ display: "block", margin: "auto" }}
          >
            Generate Instruction
          </Button>
        </Form.Item>
      </Form>
      {instruction && (
        <div
          style={{
            backgroundColor: "rgba(250, 250, 250, 1)",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          <p
            style={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px" }}
          >
            Generated Instruction:
          </p>
          <p style={{ whiteSpace: "break-spaces" }}>{instruction}</p>
        </div>
      )}
    </Modal>
  );
}
